import Ajax from 'adaptive-ui/src/js/utils/ajax';

export default class Search {

    constructor(searchButton) {
        const _this = this;

        const search = document.querySelector('[data-search]');

        this.searchButton = searchButton;
        this.searchOverlay = search.querySelector('[data-search-overlay]');
        this.searchOverlayInput = this.searchOverlay.querySelector('[data-search-overlay-input]');
        this.searchOverlayResults = this.searchOverlay.querySelector('[data-search-overlay-results]');
        this.searchOverlayNoResults = this.searchOverlay.querySelector('[data-search-overlay-no-results]');
        this.searchOverlayMessage = this.searchOverlay.querySelector('[data-search-overlay-message]');
        this.searchOverlayMore = this.searchOverlay.querySelector('[data-search-overlay-more]');
        this.searchOverlayCloseButton = this.searchOverlay.querySelector('[data-search-overlay-close]');
        this.requestTimer = null;
        this.resultExists = false;
        this.searchDataCache = {};

        if (!this.searchButton || !this.searchOverlayInput) {
            return;
        }

        this.searchButton.addEventListener('click', (event) => {
            event.preventDefault();

            _this.searchOverlay.classList.toggle('is-active');
            document.body.classList.toggle('aui-lock-scroll')
            _this.searchOverlayInput.focus();
        });

        this.searchOverlayCloseButton.addEventListener('click', function (event) {
            event.preventDefault();
            _this.onClose();
        });

        document.addEventListener('keyup', function (e) {
            if (e.key === 'Escape') {
                _this.onClose();
            }
        });

        this.searchOverlayInput.addEventListener('keyup', (event) => _this.onInputChange(event));
        this.searchOverlayInput.addEventListener('paste', (event) => _this.onInputChange(event));
    }

    onInputChange(event) {
        const _this = this;

        clearTimeout(this.requestTimer);

        this.requestTimer = setTimeout(() => _this.search(), 500);

        if (event.type !== 'paste') {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onClose() {
        this.searchOverlay.classList.remove('is-active');
        this.clearInput();
        document.body.classList.remove('aui-lock-scroll');
    }

    search() {
        const q = this.searchOverlayInput.value;

        if (q.length >= 3) {
            this.searchOverlayMessage.style.display = 'none';

            if (this.searchDataCache[q] !== undefined) {
                this.showResult(this.searchDataCache[q]);
            } else {
                this.searchRequest(q);
            }
        } else {
            this.searchOverlayMessage.style.display = 'block';
            this.clearResults();
            this.hideNoResults();
            this.showMessage();
            this.resultExists = false;
        }
    }

    showResult(responseHtml) {
        const emptyResponse = responseHtml === '' || responseHtml === null || responseHtml === undefined;

        if (emptyResponse) {
            this.showNoResults();
        } else {
            this.hideNoResults();
            this.showSearchOverlayMore();
        }

        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = responseHtml;

        if (emptyResponse) {
            this.searchOverlayResults.innerHTML = '';
        } else {
            this.searchOverlayResults.innerHTML = responseHtml;
        }
    }

    searchRequest(q) {
        const _this = this;

        Ajax.get(this.searchOverlayInput.dataset.searchAutocompleteUrl, { q: q }, { history: false, contentType: 'json' })
            .then((response) => {
                _this.searchDataCache[q] = response.searchResults;
                _this.showResult(response.searchResults);
            })
            .catch(() => {
                _this.showNoResults();
            });
    }

    showMessage() {
        this.searchOverlayMessage.style.display = 'block';
    }

    hideMessage() {
        this.searchOverlayMessage.style.display = 'none';
    }

    showNoResults() {
        this.hideMessage();
        this.clearResults();
        this.hideSearchOverlayMore();
        this.searchOverlayNoResults.style.display = 'block';
    }

    hideNoResults() {
        this.searchOverlayNoResults.style.display = 'none';
    }

    clearResults() {
        this.searchOverlayResults.innerHTML = '';
        this.hideSearchOverlayMore();
    }

    clearInput() {
        this.searchOverlayInput.value = '';
        this.clearResults();
        this.hideNoResults();
        this.showMessage();
    }

    showSearchOverlayMore() {
        const searchOverlayMoreLink = this.searchOverlayMore.querySelector('[data-search-overlay-more-link]');

        const prototype = searchOverlayMoreLink.dataset.linkPrototype;
        const searchUrl = prototype.replace('__query__', this.searchOverlayInput.value);

        searchOverlayMoreLink.setAttribute('href', searchUrl);

        this.searchOverlayMore.style.display = 'flex';
    }

    hideSearchOverlayMore() {
        const searchOverlayMoreLink = this.searchOverlayMore.querySelector('[data-search-overlay-more-link]');

        searchOverlayMoreLink.setAttribute('href', '#');
        this.searchOverlayMore.style.display = 'none';
    }

    static init(container) {
        container.querySelectorAll('[data-search-button]').forEach(element => {
            new Search(element);
        });
    };

}

naja.addEventListener('init', () => {
    Search.init(document.body);
});

naja.snippetHandler.addEventListener('afterUpdate', (event) => {
    Search.init(event.detail.snippet);
});
